import axios from "axios";
import { useAuthStore } from "../../stores/stores";
import { HelpService } from "../../service/helper.service";
import { message } from "antd";

export const BASE_URL = process.env.REACT_APP_BASE_API_URL_V2?.slice(0, -4);
const helpService = new HelpService();
export const axiosConfigAccountV2 = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosConfigAccountV2.interceptors.request.use(
  (config) => {
    const accessToken = useAuthStore.getState().accessToken;
    if (!config.headers["Authorization"] || accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const lang = localStorage.getItem("mooc_language") || "vi";
    config.headers["Accept-Language"] = lang;
    return config;
  },
  (error) => Promise.reject(error)
);

axiosConfigAccountV2.interceptors.response.use(
  (response) => response,
  async (error) => {
    const prevRequest = error?.config;

    if (!error.response) {
      console.error("Network or CORS error:", error.message);

      message.error("Lỗi mạng hoặc CORS: Không thể kết nối tới máy chủ.");
      return Promise.reject(error);
    }

    if (error?.response?.status === 403 && !prevRequest?.sent) {
      prevRequest.sent = true;
      try {
        const refreshToken = useAuthStore.getState().refreshToken;
        const accessToken = useAuthStore.getState().accessToken;
        if (refreshToken && accessToken) {
          prevRequest.headers["Authorization"] = `Bearer ${accessToken}`;
          return axiosConfigAccountV2(prevRequest);
        }
      } catch (error) {
        location.replace("/login");
      }
    } else if (
      error?.response?.status === 401 ||
      error?.response?.status === 503
    ) {
      const logout = useAuthStore.getState().logout;
      logout();
    } else {
      helpService.showMessageErrorAPI(error);
    }
    return Promise.reject(error);
  }
);
